import React from 'react';
import { Form, Modal, Row, Col } from 'react-bootstrap';
import ExpandingTextArea from 'react-expanding-textarea';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import HelpService from 'services/HelpService';
import BootboxHelper from 'helpers/BootboxHelper';

// Components
import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class EditHelpArticleModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.opts = opts;
            this.helpArticleID = opts.helpArticleID;
            this.vendorID = opts.vendorID;
            this.resolve = resolve;
            this.loginInfo = GlobalStateService.getValue('loginInfo');

            this.setState({
                isOpen: true,
                isLoading: true
            });
            this.load();
        });
    }

    close() {
        this.setState({
            isOpen: false
        });
    }

    async load() {
        let helpArticle;
        if (this.helpArticleID) {
            helpArticle = await HelpService.getArticle(this.helpArticleID);
        } else {
            helpArticle = {
            };
        }

        this.setState({
            helpArticle,
            isLoading: false
        });
    }

    updateFields(values) {
        let loadVendorSpecific;
        const helpArticle = { ...this.state.helpArticle };
        for (var field in values) {
            let value = values[field];
            helpArticle[field] = value;
        }
        this.setState({ helpArticle });
    }

    async saveAndClose() {
        this.setState({ isLoading: true });
        try {
            await HelpService.saveArticle(this.state.helpArticle);
            this.close();
            this.resolve();
        } catch (error) {
            BootboxHelper.alert(error);
            this.setState({ isLoading: false });
        }
    }

    async confirmDelete() {
        const confirm = await BootboxHelper.confirm('Are you sure you want to delete this help article?');
        if (confirm) {
            this.delete();
        }
    }

    async delete() {
        this.setState({ isLoading: true });
        await HelpService.deleteArticle(this.state.helpArticle.id);
        this.close();
        this.resolve();
    }

    render() {
        const {
            isOpen
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (<>

            <Modal show className="edit-help-article-modal">
                {this.renderInner()}
            </Modal>

        </>);
    }

    renderInner() {
        const {
            isLoading,
            helpArticle,
            isReadOnly
        } = this.state;

        if (isLoading) {
            return (
                <Modal.Body>
                    <Loader />
                </Modal.Body>
            );
        }

        return (

            <form onSubmit={e => { e.preventDefault(); this.saveAndClose() }} className={isReadOnly ? ' read-only-form' : ''}>
                <Modal.Body>

                    <Form.Group className="mb-3">
                        <Form.Label>Title</Form.Label>
                        <input
                            className="form-control"
                            type="text"
                            value={helpArticle.title || ''}
                            onChange={e => this.updateFields({ title: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Slug</Form.Label>
                        <input
                            className="form-control"
                            type="text"
                            value={helpArticle.slug || ''}
                            onChange={e => this.updateFields({ slug: e.target.value })}
                            placeholder="Leave blank to generate automatically"
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Body</Form.Label>
                        <ExpandingTextArea
                            className="form-control monospace"
                            type="text"
                            value={helpArticle.body || ''}
                            onChange={e => this.updateFields({ body: e.target.value })}
                            rows={4}
                        />
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary me-auto" onClick={() => this.close()}>
                        Close
                    </button>
                    {!isReadOnly && helpArticle.id &&
                        <button type="button" className="btn btn-danger ms-auto me-auto" onClick={() => this.confirmDelete()}>
                            Delete
                        </button>
                    }
                    {!isReadOnly &&
                        <button type="submit" className="btn btn-primary ms-auto">
                            Save
                        </button>
                    }
                </Modal.Footer>
            </form>
        );
    }
}

export default EditHelpArticleModal;